import { cardSurface } from '@components/Card'
import { media } from '@/theme/tokens'
import styled from 'styled-components'

/**
 * The public map's frame inside the page column: one card, like the itinerary
 * card it opens from, filling what the viewport has left above the tabletWide
 * breakpoint. Below it the map view stacks by percentages, so the card takes a
 * fixed height they can divide.
 */
export const MapCard = styled.div`
	${cardSurface}
	padding: 0;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	height: 720px;

	${media.aboveTabletWide} {
		height: auto;
		flex: 1 1 0;
		min-height: 620px;
	}
`
